import React from "react";
import { MapContext } from "./StateContext";

export const StateProvider = (props) => {
  const [coords, setCoords] = React.useState({ lat: 0, lng: 0 });
  const [code, setCode] = React.useState("");
  const [searchCoords, setSearchCoords] = React.useState(null);
  const [showRegisterForm, setShowRegisterForm] = React.useState(false);
  const [showShareModal, setShowShareModal] = React.useState(false);
  const [addressData, setAddressData] = React.useState(null);
  const [addressFormHydratingValues, setAddressFormHydratingValues] =
    React.useState(null);
  const [searchKeywords, setSearchKeywords] = React.useState("");

  const [isSearching, setIsSearching] = React.useState(false);

  return (
    <MapContext.Provider
      value={{
        coords,
        setCoords,
        code,
        setCode,
        searchCoords,
        setSearchCoords,
        showRegisterForm,
        setShowRegisterForm,
        showShareModal,
        setShowShareModal,
        addressData,
        setAddressData,
        addressFormHydratingValues,
        setAddressFormHydratingValues,
        searchKeywords,
        setSearchKeywords,

        isSearching,
        setIsSearching,
      }}
    >
      {props.children}
    </MapContext.Provider>
  );
};
